import { IMessageBarProps, MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";

import { Text } from "./Text";

export interface WarningMessageProps extends Pick<IMessageBarProps, "styles"> {
    message: string;
    onClick?(): void;
    testId?: string;
}

export const WarningMessage: React.FC<WarningMessageProps> = ({
    message,
    styles,
    onClick,
    testId
}: WarningMessageProps) => {
    return (
        <MessageBar messageBarType={MessageBarType.warning} isMultiline={true} styles={styles} data-testid={testId}>
            <Text block={false} nowrap={false} variant="smallPlus" onClick={onClick}>
                {message}
            </Text>
        </MessageBar>
    );
};
